import { Globals, SceneBase as SceneRawBase } from "@ortho-next/three-base";
import { AmbientLight, DirectionalLight, Vector2 } from "three";
import { EffectComposer, OutlinePass, OutputPass, RenderPass } from "three/addons";
import { CustomCamera } from "../Controls/CustomCamera.js";
import { CustomCameraControls } from "../Controls/CustomCameraControls.js";
import { ViewType } from "../Models/AppModel.js";
/**
 * Scene to render. Contains all tools, lights, camera and camera controls.
 */
export class SceneBase extends SceneRawBase {
    // TODO REMOVE IT AFTER THREE.JS FIX. THIS ARE NECESSARY DUE TO THREE.JS D.TS BUG NOT BEING GENERIC
    dispatchEvent(event) {
        super.dispatchEvent(event);
    }
    addEventListener(type, listener) {
        super.addEventListener(type, listener);
    }
    constructor(renderer, viewType, toolsProto, useOutlinePass, cameraControlsProto = CustomCameraControls) {
        super(new CustomCamera(), new toolsProto());
        this._deselectCurrentToolEvent = () => { this.deselectCurrentTool(); };
        this.name = ViewType[viewType];
        this.viewType = viewType;
        if (useOutlinePass) {
            this.composer = new EffectComposer(renderer);
            const renderPass = new RenderPass(this, this.camera);
            this.composer.addPass(renderPass);
            this.outlinePass = new OutlinePass(new Vector2(Globals.canvasContainer.clientWidth, Globals.canvasContainer.clientHeight), this, this.camera);
            this.composer.addPass(this.outlinePass);
            const outputPass = new OutputPass();
            this.composer.addPass(outputPass);
            this.outlinePass.edgeStrength = 10;
            this.outlinePass.edgeThickness = 1;
            this.outlinePass.hiddenEdgeColor.set(0xffffff);
        }
        this.cameraControls = new cameraControlsProto(this.camera, viewType);
        this.initLights();
        this.bindEvents();
    }
    initLights() {
        const ambientLight = new AmbientLight('white', 3);
        const dirLight = new DirectionalLight('white', 2).translateZ(5000);
        this.add(ambientLight, dirLight);
    }
    bindEvents() {
        this.bindEvent("onClick", (args) => {
            const tool = this.getSelectableToolFromChildren(args.object);
            if (tool != this.activeTool) {
                this.deselectCurrentTool();
                this.activeTool = tool;
                if (tool !== undefined) {
                    tool.isSelected = true;
                    tool.onSelect();
                    tool.dispatchEvent({ type: 'select', args: tool });
                    this.dispatchEvent({ type: 'select', args: tool });
                    tool.addEventListener('deselect', this._deselectCurrentToolEvent); //you can deselect a tool triggering this event from tool instance
                }
            }
        });
    }
    deselectCurrentTool() {
        if (this.activeTool) {
            this.activeTool.isSelected = false;
            this.activeTool.onDeselect();
            this.activeTool.removeEventListener('deselect', this._deselectCurrentToolEvent);
            this.activeTool.dispatchEvent({ type: 'deselect', args: this.activeTool });
            this.dispatchEvent({ type: 'deselect', args: this.activeTool });
            this.activeTool = undefined;
        }
    }
    deleteActiveTool() {
        if (this.activeTool?.isDeletable) {
            const disposeObject = this.activeTool.onDeleted?.() === true;
            this.activeTool.dispatchEvent({ type: 'delete', args: this.activeTool });
            this.dispatchEvent({ type: 'delete', args: this.activeTool });
            if (disposeObject) {
                this.activeTool.dispose();
            }
            this.activeTool = undefined;
        }
    }
    getSelectableToolFromChildren(mesh) {
        if (mesh.isSelectable !== undefined) {
            return mesh;
        }
        return mesh.parent ? this.getSelectableToolFromChildren(mesh.parent) : undefined;
    }
}
//# sourceMappingURL=Scene.js.map